import {
  ButtonGroup,
  IconButton,
  SkeletonText,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { flexRender } from "@tanstack/react-table";
import iconArrowLeftRight from "assets/icons/icon-arrow-left-right.svg";
import IconEye from "assets/icons/icon-eye.svg?react";
import ButtonRemoveResource from "components/ButtonRemoveResource";
import EmptyList from "components/ui/EmptyList";
import IconButtonEdit from "components/ui/IconButtonEdit";
import Pagination from "components/ui/Pagination";
import { useServerDynamicTableContext } from "contexts/server-table/ServerDynamicTableContext";
import { usePermissionsContext } from "contexts/PermissionsContext";
import { Link, useLocation } from "react-router-dom";

export default function EmailsList() {
  const location = useLocation();
  const { table, queryResult } = useServerDynamicTableContext();
  const total = queryResult?.data?.meta?.total || 0;
  const isLoading = queryResult?.isLoading || false;

  const hasData = total > 0;
  const hasResult = table.getRowModel().rows.length > 0;

  const { user } = usePermissionsContext();

  return (
    <SkeletonText isLoaded={!isLoading}>
      {hasResult && (
        <>
          <Table mt="25px">
            <Thead>
              <Tr>
                <Th>Modelo</Th>
                <Th>Título</Th>
                <Th w="100px">Status</Th>
                <Th w="100px">Destinatários</Th>
                <Th w="100px">Enviados</Th>
                <Th w="100px">Bounce</Th>
                <Th w="100px">Criado por</Th>
                <Th w="100px">Criado em</Th>
                <Th w="100px">Enviado em</Th>
                <Th w="100px"></Th>
              </Tr>
            </Thead>
            <Tbody>
              {table.getRowModel().rows.map((row) => {
                const rowData = row.original as Record<string, unknown>;
                const isOnlyNewsletter = Boolean(rowData.isOnlyNewsletter);
                const hasEmail = Boolean(rowData.email);
                const composesNewsletter = Boolean(rowData.composesNewsletter);
                const canEdit =
                  (user?.role === 'admin' || user?.role === 'partner') ||
                  (!isOnlyNewsletter && !hasEmail) ||
                  (isOnlyNewsletter && !composesNewsletter);
                const canDelete =
                  (!isOnlyNewsletter && !hasEmail) ||
                  (isOnlyNewsletter && !composesNewsletter);
                return (
                  <Tr key={`row-${row.id}`}>
                    {row.getVisibleCells().map((cell) => (
                      <Td key={cell.id}>
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </Td>
                    ))}
                    <Td>
                      <ButtonGroup>
                        <IconButton
                          aria-label="Visualizar"
                          size="sm"
                          icon={<IconEye />}
                          as={Link}
                        to={{
                          pathname: `/disparos-de-report/${String(rowData.id)}`,
                          search: location.search,
                        }}
                        />
                        {canEdit && (
                          <IconButtonEdit
                            to={{
                              pathname: `/disparos-de-report/editar/${String(rowData.id)}/conteudo`,
                              search: location.search,
                            }}
                          />
                        )}
                        {canDelete && (
                          <ButtonRemoveResource
                            id={rowData.id as string}
                            pathName="contents"
                            queryKey="contents"
                          />
                        )}
                      </ButtonGroup>
                    </Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>

          <Pagination table={table} />
        </>
      )}

      {(!hasData || !hasResult) && (
        <EmptyList
          mt="25px"
          icon={iconArrowLeftRight}
          title={
            !hasData
              ? "Você ainda não possui nenhum disparo de Report cadastrado"
              : "Nenhum resultado encontrado"
          }
          description={hasData ? "" : "Use o botão acima para cadastrar"}
          isTable
        />
      )}
    </SkeletonText>
  );
}
